"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FloatingInventoryEntity_1 = __importDefault(require("./Entity/FloatingInventoryEntity"));
var FloatingInventory = /** @class */ (function () {
    function FloatingInventory(session) {
        this.floatingInventory = new FloatingInventoryEntity_1.default(session);
    }
    FloatingInventory.prototype.getUsersWithAvailableFloatingInventory = function (taskId) {
        return this.floatingInventory.getUsersWithAvailableFloatingInventory(taskId);
    };
    return FloatingInventory;
}());
exports.default = FloatingInventory;
//# sourceMappingURL=FloatingInventoryApi.js.map